var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.newsletter.webViewLink,"target":"_blank"}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.fileDate))]),_c('i',{staticClass:"fas fa-file-pdf"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }